function setFavicon({ input }) {
  let client = input.result.client
  if (client.favicon) {
    let link = document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = `${client.favicon}`
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}

export default setFavicon



// WEBPACK FOOTER //
// ./src/modules/app/actions/setFavicon.js